import React, { useEffect, useState } from 'react';

import { InfoCircleOutlined } from '@ant-design/icons';
import { operationalInformation } from '@app/services/aboutCompany/operationalInformation';
import { useAppSelector } from '@hooks/shared/reduxHooks';
import { useResponsive } from '@hooks/shared/useResponsive';
import { Container } from '@styled/shared/Container';
import { Typography } from 'antd';
import { t } from 'i18next';

const { Text } = Typography;

interface IInfoUnit {
	key: number;
	title: string;
	value: number | string;
}

const OverdraftInfo = () => {
	const { mobileOnly } = useResponsive();
	const client = useAppSelector((state) => state.user.client);
	const [info, setInfo] = useState<IInfoUnit[]>([]);

	useEffect(() => {
		if (!client) return;
		setInfo(operationalInformation(client));
	}, [client]);

	const userMessage = info.reduce((acc, item) => {
		switch (item.key) {
			case 1:
				acc += `${t('overdraftInfo.yourOverdraft')} ${item.value} ${t('overdraftInfo.uahCurrencyCode')}, `;
				break;
			case 2:
				if (typeof item.value !== 'number')
					acc += `${t('overdraftInfo.overdraftStatus')} - ${item.value.toLowerCase()}. `;
				break;
			case 3:
				acc += `${t('overdraftInfo.youHave')} ${t('overdraftInfo.postponement')} - ${item.value} ${t('overdraftInfo.days')}, `;
				break;
			case 4:
				if (item.value === 0) {
					acc += `${t('overdraftInfo.noDebt')}. `;
				}
				break;
			case 5:
				if (typeof item.value === 'number' && item.value > 0)
					acc += `${t('overdraftInfo.overdue')} ${item.value} ${t('overdraftInfo.debtDays')}, `;
				break;
			case 7:
				if (typeof item.value === 'number' && item.value > 0)
					acc += `${t('overdraftInfo.debtAmount')} ${item.value} ${t('overdraftInfo.uahCurrencyCode')}, `;
				break;
			case 8:
				if (typeof item.value === 'number' && item.value > 0)
					acc += `${t('overdraftInfo.blockAlert')} ${item.value} ${t('overdraftInfo.days')}.`;
				break;
			default:
				break;
		}
		return acc;
	}, '');

	if (info[0]?.value === 0) return null;

	return client?.overdraftStatus === '-1' ? null : (
		<Container
			className='content-wrapper'
			style={{
				backgroundColor: `var(--${client?.overdraftStatus === 1 ? 'red' : 'gray'}UltraLight)`,
			}}
			vertical={mobileOnly}
			align='flex-start'
			gap={16}>
			<InfoCircleOutlined
				style={{
					fontSize: '24px',
					color: `var(--${client?.overdraftStatus === 1 ? 'red' : 'green'}`,
				}}
			/>
			<Text>{userMessage}</Text>
		</Container>
	);
};

export default OverdraftInfo;
